// extracted by mini-css-extract-plugin
module.exports = {"root":"PricingBlockServices_root__P0NIH","title":"PricingBlockServices_title__OAkY8","included":"PricingBlockServices_included__g_aDz"};